<p>collect-payment works!</p>
